import React from 'react';
import backgroundImage from '../assets/test4.jpg';
import PageBanner from "../components/ui/PageBanner";
import useSEO from "../hooks/useSEO";

const Cenik = () => {
    useSEO({
        title: "Ceník — Fyzioterapie Frýdek-Místek | UrbanFyzio",
        description: "Transparentní ceník služeb. Vstupní kineziologický rozbor 1000 Kč, individuální fyzioterapie a další služby od 800 Kč.",
        path: "/cenik",
    });

    const services = [
        { name: "Vstupní kineziologický rozbor", duration: "1 hodina", price: "1000 CZK", link: "https://urbanfyzio.reservio.com/booking?step=2&serviceId=bedadea0-0722-4797-94aa-c2962455e8a1&resourceId=anyone-available", featured: true },
        { name: "Individuální fyzioterapie", duration: "55 minut", price: "800 CZK", link: "https://urbanfyzio.reservio.com/booking?step=2&serviceId=5240099f-9f44-4d73-a74d-02862e2cc972&resourceId=anyone-available" },
        { name: "Měkké a mobilizační techniky", duration: "45 minut", price: "800 CZK", link: "https://urbanfyzio.reservio.com/booking?step=2&serviceId=ed85b79b-3cdf-419a-8098-22ba4c690668&resourceId=anyone-available" },
        { name: "Individuální cvičení pod dohledem fyzioterapeuta", duration: "1 hodina", price: "800 CZK", link: "https://urbanfyzio.reservio.com/booking?step=2&serviceId=1757217e-4242-4839-9644-ea05089dcb45&resourceId=anyone-available" },
    ];

    return (
        <div className="flex flex-col bg-surface min-h-screen">
            <PageBanner
                title="Ceník"
                subtitle="Transparentní ceny mých služeb"
                backgroundImage={backgroundImage}
            />

            <div className="container-narrow section py-12 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className={`card card-hover p-6 md:p-7 flex flex-col ${
                                service.featured ? 'ring-1 ring-brand-200 bg-soft-sky relative' : ''
                            }`}
                        >
                            {service.featured && (
                                <span className="badge-brand absolute -top-3 left-6">Doporučuji jako první návštěvu</span>
                            )}
                            <div className="flex items-start justify-between gap-4">
                                <div className="flex-1 min-w-0">
                                    <h3 className="text-lg md:text-xl font-semibold text-ink-900 leading-snug">
                                        {service.name}
                                    </h3>
                                    <div className="mt-2 inline-flex items-center gap-1.5 text-sm text-ink-500">
                                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="12" cy="12" r="10" />
                                            <polyline points="12 6 12 12 16 14" />
                                        </svg>
                                        {service.duration}
                                    </div>
                                </div>
                                <div className="text-right">
                                    <div className="text-2xl md:text-3xl font-bold text-brand-700 whitespace-nowrap">{service.price}</div>
                                </div>
                            </div>
                            <a
                                href={service.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-primary mt-6 w-full"
                            >
                                Rezervovat
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12" />
                                    <polyline points="12 5 19 12 12 19" />
                                </svg>
                            </a>
                        </div>
                    ))}
                </div>

                {/* Notes */}
                <div className="mt-10 card p-6 md:p-7 bg-white">
                    <h4 className="text-sm font-semibold text-ink-900 mb-4 uppercase tracking-wider">Důležité informace</h4>
                    <ul className="space-y-3 text-sm md:text-base text-ink-600">
                        <li className="flex items-start gap-3">
                            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-brand-500 flex-shrink-0" />
                            <span>Platba v hotovosti nebo přes QR kód — platební karty zatím nepřijímám.</span>
                        </li>
                        <li className="flex items-start gap-3">
                            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-brand-500 flex-shrink-0" />
                            <span>V případě nezrušení rezervace včas je účtována plná cena služby.</span>
                        </li>
                        <li className="flex items-start gap-3">
                            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-brand-500 flex-shrink-0" />
                            <span>Nemáme smlouvy se zdravotními pojišťovnami.</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Cenik;
